import { defineAsyncComponent } from 'vue'
export default {
  callcenter: defineAsyncComponent(() => import("/github/workspace/layouts/callcenter.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/github/workspace/layouts/default.vue").then(m => m.default || m))
}